import { render, staticRenderFns } from "./DefaultProgramsView.vue?vue&type=template&id=36f56e50&scoped=true"
import script from "./DefaultProgramsView.vue?vue&type=script&lang=js"
export * from "./DefaultProgramsView.vue?vue&type=script&lang=js"
import style0 from "./DefaultProgramsView.vue?vue&type=style&index=0&id=36f56e50&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f56e50",
  null
  
)

export default component.exports